import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideForWho() {
  const forWho = ['Persoane care simt că nu primesc suficient din viață. Dai mult, te implici, te dedici, dar parcă viața nu îți oferă la fel. Vrei să înțelegi de ce și cum să schimbi asta.', 'Oameni care își doresc mai mult decât bani, vor echilibru, sănătate, relații armonioase, liniște interioară. Vor abundență pe toate planurile, nu doar pe cel financiar.', 'Femei și bărbați care se simt blocați emoțional sau energetic. Se simt obosiți, fără energie, fără claritate și caută o cale de a se reîncărca.', 'Persoane interesate de evoluție spirituală care simt că există mai mult în viață decât ceea ce trăiesc acum, dar nu știu cum să ajungă acolo.'];
  const notForWho = ['Persoane care caută doar tehnici financiare rapide. Acest curs lucrează cu energia, emoțiile și mentalitatea ta, nu cu strategii de investiții.', 'Cei care nu cred în dezvoltare personală sau spiritualitate și nu sunt dispuși să încerce o abordare diferită a vieții.', 'Oameni care nu sunt dispuși să aplice exercițiile. Uneltele din curs funcționează doar dacă le folosești. Informația fără practică nu schimbă nimic.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1046">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1047">
        <SectionHeading title="Pentru cine este acest curs" data-id="element-1048" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1049">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-1050">
            <div className="flex items-center gap-4 mb-8" data-id="element-1051">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1052">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-1053" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1054">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1055">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1056">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-1057" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1058">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-1059">
            <div className="flex items-center gap-4 mb-8" data-id="element-1060">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1061">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-1062" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1063">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1064">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1065">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-1066" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1067">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1068">
          <CTAButton data-id="element-1069" />
        </motion.div>
      </div>
    </section>;
}